import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import App from './app';
import './i18n';

import { SpinnerComponent } from './components/common/spinnerComponent';

const rootElement = document.getElementById('root');

ReactDOM.render( 
    <Suspense fallback={<SpinnerComponent/>}>
        <App />
    </Suspense>,
    rootElement
);


